<span class="ratings" *ngIf="ratingStars.length > 0">
	<span *ngFor="let star of ratingStars" class="rating-star">
    <i class="fa fa-star {{star}}"></i>
	</span>
	<span><strong>Hotel</strong></span>
</span>
